<script setup lang="ts">
import type { ISegmentControlsOption } from '@/features/ui-kit';
import { SegmentControl } from '@/features/ui-kit';
import { useDevToolbar } from '../../business/form';

const { formData } = useDevToolbar();

const options: Array<ISegmentControlsOption> = [
  { label: 'Prod', value: 'production' },
  { label: 'Dev', value: 'development' },
  { label: 'Release', value: 'release' },
  { label: 'Auto', value: 'auto' },
];
</script>

<template>
  <div class="api-tab">
    <SegmentControl label="API" :options="options" v-model="formData.api.value" />
  </div>
</template>

<style scoped lang="stylus">
.api-tab
  display flex
  flex-direction column
</style>
